import { mockArticle, mockArticleSlug, mockArticleTopic } from './article.mock';
import { Article, ArticleRequestParams } from './article.types';

/**
 * Mock article fetch until LAAC-2089/2090 publish path + envelope.
 */
export const fetchArticleByTopicAndSlug = async ({ slug, topic }: ArticleRequestParams): Promise<Article | null> => {
    if (topic === mockArticleTopic && slug === mockArticleSlug) {
        return mockArticle;
    }

    return null;
};
